var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArcticonsDocumentViewerVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70829 2.15625H5.03121C4.77704 2.15625 4.53329 2.25722 4.35357 2.43694C4.17384 2.61666 4.07288 2.86042 4.07288 3.11458V19.8854C4.07288 20.1396 4.17384 20.3833 4.35357 20.5631C4.53329 20.7428 4.77704 20.8437 5.03121 20.8437H17.9687C18.2229 20.8437 18.4666 20.7428 18.6464 20.5631C18.8261 20.3833 18.927 20.1396 18.927 19.8854V3.11458C18.927 2.86042 18.8261 2.61666 18.6464 2.43694C18.4666 2.25722 18.2229 2.15625 17.9687 2.15625H11.5",
    stroke: "#EC3337",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 2.15624L6.42754 1.4787C6.60722 1.29896 6.85094 1.19796 7.10508 1.19791H11.0208C11.1479 1.19791 11.2698 1.24839 11.3597 1.33825C11.4495 1.42811 11.5 1.54999 11.5 1.67707V13.6562L9.10417 11.2604L6.70833 13.6562V2.15624M6.70833 18.2083H16.2917M11.5 4.79166H16.2917M11.5 8.14582H16.2917M11.5 11.5H16.2917M6.70833 14.8542H16.2917",
    stroke: "#EC3337",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcticonsDocumentViewerVector);
export default __webpack_public_path__ + "static/media/arcticons_document-viewerVector.8997ae4e75eaf77d9e819c6ad6365c39.svg";
export { ForwardRef as ReactComponent };